import React from 'react';
import './Tree.scss';
import Tag from '../tag/Tag';
import Gift from '../gift/Gift';
import Parse from "parse";
import treeImage from './christmas_tree.svg';
import Snowflake from './Snowflakes';
import TagSelector from './TagSelector';
import Rodal from 'rodal';
import * as QueryString from "query-string";
import { withRouter } from "react-router";

// include styles
import 'rodal/lib/rodal.css';

class Tree extends React.Component {
    constructor() {
        super();

        this.state = {
            tags: [],
            gifts: [],
            isTagsLoaded: false,
            isTagsRemaining: true,
            isGiftsLoaed: false,
            isWelcomeAcknowledged: false,
            tagModal: { visible: false, tag: {}, familyTags: [], selections: {} },
            thankYouModal: { visible: false, count: 0, savedCount: 0, text: '' },
            helpModal: { visible: false, page: '1' }
        }
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    reloadTree() {
        var that = this;
        var Tag = Parse.Object.extend("Tag");

        var tagsQuery = new Parse.Query(Tag);
        // tagsQuery.matches('Status', 'Available');
        tagsQuery.ascending('Family');
        tagsQuery.addAscending('ChildNumber');
        tagsQuery.limit(500);
        tagsQuery.find().then(function(tags){
            // Check if tag reserved stasuses have expired.
            var now = new Date().getTime();
            for (const property in tags) {
                var tag = tags[property];
                if (tag.get("Status") === 'Reserved') {
                    var tagTime = tag.get("updatedAt").getTime();
                    if ((now - tagTime) > 300000) { // 5 minute differential
                        tag.set("Status", 'Available');
                        tag.save();
                    }
                }
            }
            var tagsArray = JSON.parse(JSON.stringify(tags)),
                isTagsRemaining = false;

            for (const property in tagsArray) {
                var tag2 = tagsArray[property];
                if (tag2.Status !== 'Taken') {
                    isTagsRemaining = true;
                    break;
                }
            }

            // tagsArray.push({ "Status": "Available" });
            // tagsArray.push({ "Status": "Available" });
            // tagsArray.push({ "Status": "Available" });
            // tagsArray.push({ "Status": "Available" });
            // tagsArray.push({ "Status": "Available" });
            // tagsArray.push({ "Status": "Available" });
            // tagsArray.push({ "Status": "Available" });
            // tagsArray.push({ "Status": "Available" });
            // tagsArray.push({ "Status": "Available" });
            // tagsArray.push({ "Status": "Available" });
            // tagsArray.push({ "Status": "Taken" });
            // tagsArray.push({ "Status": "Taken" });
            // tagsArray.push({ "Status": "Taken" });
            // tagsArray.push({ "Status": "Taken" });
            // tagsArray.push({ "Status": "Taken" });
            // tagsArray.push({ "Status": "Taken" });
            // tagsArray.push({ "Status": "Taken" });
            // tagsArray.push({ "Status": "Taken" });
            // tagsArray.push({ "Status": "Taken" });
            // tagsArray.push({ "Status": "Taken" });

            that.setState({
               isTagsLoaded: true,
               isTagsRemaining: isTagsRemaining,
               tags: tagsArray
            });
        }).catch(function(error){
            console.log("Error: " + error.code + " " + error.message);       
        });

        var giftsQuery = new Parse.Query(Tag);
        giftsQuery.matches('Status', 'Taken');
        giftsQuery.ascending('Family');
        giftsQuery.addAscending('ChildNumber');
        giftsQuery.limit(500);
        giftsQuery.find().then(function(tags) {

            var families = {},
                tagList = JSON.parse(JSON.stringify(tags)),
                gifts = [];

            for (const property in tagList) {
                var tag = tagList[property];
                if (families[tag.Family]) {
                    families[tag.Family].count++;
                }
                else {
                    families[tag.Family] = {
                        count: 1,
                        total: tag.TotalChildren
                    }
                }
                if (families[tag.Family].count === families[tag.Family].total) {
                    gifts.push(tag.Family);
                }
            }
            
            // gifts.push('Z');
            // gifts.push('Y');
            // gifts.push('Y');
            // gifts.push('Y');

            that.setState({
               isGiftsLoaded: true,
               gifts: gifts
             });
        }).catch(function(error){
            console.log("Error: " + error.code + " " + error.message);       
        });
    }

    componentDidMount() {
        var Tag = Parse.Object.extend("Tag");

        // Load the tags and gifts of the tree.
        this.reloadTree();

        const params = QueryString.parse(this.props.location.search);
        if (params.submittedTagIDs) {
            // Receive redirect from Cognito Form with taken tag details.
            var tagIDs = params.submittedTagIDs.split(","),
                takenByEmail = params.takenByEmail,
                submittedChildren = params.submittedChildren,
                savedCount = 0;

            // Update status of each taken tag.
            tagIDs.forEach(function(value, index, array) {
                var query = new Parse.Query(Tag);
                query.get(value)
                .then((tag) => {
                    // The object was retrieved successfully and it is ready to update.
                    if (tag.Status !== 'Taken') {
                        tag.set("Status", 'Taken');
                        tag.set("TakenByEmail", takenByEmail);
                        tag.save();
                    }
                }, (error) => {
                    // The object was not retrieved successfully.
                });
            });

            // Show the "thank you" modal.
            this.setState({
                "thankYouModal": {
                    visible: true,
                    text: submittedChildren,
                    count: tagIDs.length,
                    savedCount: savedCount
                },
                isWelcomeAcknowledged: true
            });
        }
    }

    changeHandler = event => {
        const name = event.target.getAttribute('id');
        const value = event.target.value;
        if (!value || value === "") {            
            this.setState({
                [`${name}Error`]: true
            })
        } else { 
            this.setState({
                [`${name}Error`]: false,
                [name]: value
            })
        }
    }

    handleSubmit = async (event) => {
        event.preventDefault();
        try{
            await Parse.User.logIn(this.state.username, this.state.password);
            alert("Logged in!");
        } catch (e){
            alert(e.message); 
        }
        
    }

    openTagModal(selectedTag) {

        var that = this;
        var Tag = Parse.Object.extend("Tag");

        var tagsQuery = new Parse.Query(Tag);
        tagsQuery.matches('Family', selectedTag.Family);
        tagsQuery.find().then(function(familyTags){
            var selections = {};
            if (selectedTag.Status === 'Available') {
                selections[selectedTag.ChildNumber] = selectedTag;
            }
            var numAvailable = 0;
            for (const property in familyTags) {
                var tag = JSON.parse(JSON.stringify(familyTags[property]));
                if (tag.Status === 'Available') {
                    numAvailable++;
                }
            }
            that.setState({
                tagModal: { visible: true, tag: selectedTag, familyTags: familyTags, numAvailable: numAvailable, selections: selections }
            });
        }).catch(function(error){
            console.log("Error: " + error.code + " " + error.message);       
        });
    }

    closeTagModal() {
        this.reloadTree();
        this.setState({ tagModal: { visible: false, tag: {}, familyTags: [], selections: {} } });
    }

    closeThankYouModal() {
        // Reload the tags and gifts of the tree (after 2 seconds);
        var that = this;
        setTimeout(function(){ that.reloadTree(); }, 2000);
        
        // Close modal.
        this.setState({ thankYouModal: { visible: false, text: '', count: 0, savedCount: 0 } });
    }

    proceedToForm(selections) {
        var familyText = '',
            family = null,
            selectedText = '',
            idsList = '',
            idsMap = {},
            tagsList = '',
            noLongerAvailable = false;

        var that = this;
        var Tag = Parse.Object.extend("Tag");

        for (const property in selections) {
            var tag = selections[property];
            if (tag != null) {
                family = tag.Family;
                familyText = 'Family ' + tag.Family;
                if (tagsList !== '') {
                    tagsList += ', ';
                    idsList += ',';
                    selectedText += ', ';
                }
                idsList += tag.objectId;
                idsMap[tag.objectId] = true;
                tagsList += tag.Family + tag.ChildNumber;
                selectedText += tag.Gender + ' (' + tag.AgeText + ' old)';
            }
        }

        if (tagsList === '') {
            alert('Please select at least one child to continue.');
        }
        else {
            // Double check that these selections are still available, then save them as reserved.
            var tagsQuery = new Parse.Query(Tag);
            tagsQuery.matches('Family', family);
            tagsQuery.find().then(function(familyTags){
                for (const property in familyTags) {
                    var tag = JSON.parse(JSON.stringify(familyTags[property]));
                    if (idsMap[tag.objectId] && tag.Status !== 'Available') {
                        noLongerAvailable = true;
                        break;
                    }
                }
                
                // Child is no longer available!
                if (noLongerAvailable) {
                    alert("Sorry, one of the children you selected is no longer available. Please change your selection.");
                    that.reloadTree();
                }
                else {
                    // Save selected children with reserved status.
                    for (const property in familyTags) {
                        var tag2 = JSON.parse(JSON.stringify(familyTags[property]));
                        if (idsMap[tag2.objectId]) {
                            familyTags[property].set("Status", 'Reserved');
                            familyTags[property].save();
                        }
                    }

                    // Open to contact form.
                    var selectedChildren = familyText + ': ' + selectedText;
                    window.location = 'https://www.cognitoforms.com/RestorationChurch3/TheGivingTreeCompleteYourSelections?entry={"SelectedTagIDs": "' + idsList + '","SelectedTags": "' + tagsList + '","SelectedChildren": "' + selectedChildren + '"}';
                }
            }).catch(function(error){
                console.log("Error: " + error.code + " " + error.message);       
            });
        }
    }

    openGiftModal(selectedGift) {
        // TODO
        // this.setState({ tagModal: { visible: true, tag: selectedTag } });
    }

    acknowledgeWelcome() {
        this.setState({ isWelcomeAcknowledged: true } );
    }

    openHelpModal() {
        this.setState({ helpModal: { visible: true, page: '1' } });
    }

    closeHelpModal() {
        this.setState({ helpModal: { visible: false, page: '0' } });
    }

    toHelpPage2() {
        this.setState({ helpModal: { visible: true, page: '2' } });
    }

    toHelpPage3() {
        this.setState({ helpModal: { visible: true, page: '3' } });
    }

    openNotificationForm() {
        window.location = 'https://www.cognitoforms.com/RestorationChurch3/TheGivingTreeNotificationList';
    }

    render() {
        if (!this.state.isWelcomeAcknowledged) {
            return (
                <div id="tree">    
                    <Rodal height={750} visible={!this.state.isWelcomeAcknowledged} onClose={this.acknowledgeWelcome.bind(this)}>
                    
                            <h3 className="text-center">Welcome to the Giving Tree!</h3>
                            {this.state.isTagsRemaining &&
                                <p>
                                    The Giving Tree is our annual opportunity to bless those in our community who might have a hard time providing a happy Christmas to their family.
                                    Each tag on the tree represents a child from a family in need.  By taking a tag off the tree, you pledge to work with others from RC to come around this family with $50-$100 towards each selection.
                                    Simply click a tag to "take" it off the tree, confirm your selection, then fill out your contact information and we will send you further instructions.
                                    <br></br>
                                    <br></br>
                                    As the tags are taken, see how the tree transforms with Christmas cheer!  Each sponsored child is represented by an ornament and each fully sponsored family by a gift under the tree!
                                </p>
                            }
                            {!this.state.isTagsRemaining &&
                                <p>
                                    The Giving Tree is our annual opportunity to bless those in our community who might have a hard time providing a happy Christmas to their family.
                                    <br></br>
                                    <br></br>
                                    GOOD NEWS!  All tags on our Virtual Giving Tree have been taken!  That means many families are being wrapped in our love this Christmas.
                                    If you are still looking for a tag, then stay tuned in case new families emerge that may add new tags to the tree.
                                    You can <a href="https://www.cognitoforms.com/RestorationChurch3/TheGivingTreeNotificationList">sign up</a> to receive notification if new tags are added.
                                    <br></br>
                                    <br></br>
                                    Continue to see how our tree of tags has transformed into a tree of ornaments!  Each ornament represents a child being sponsored and each tree a family that has been fully wrapped in love.
                                </p>
                            }
                            <div className="text-center m-t-2">
                                <button className="button button--block button--primary" onClick={this.acknowledgeWelcome.bind(this)}>Continue to the Giving Tree</button>
                            </div>
                          
                    
                    </Rodal>
            </div>

            );
        } else if (!this.state.isTagsLoaded && !this.state.isGiftsLoaded) {
          return <div id="tree">Loading...</div>;
        } else {
            return (
            
                <div id="tree">
                    <Snowflake />

                    <Rodal height={600} visible={this.state.tagModal.visible} onClose={this.closeTagModal.bind(this)}>
                        <h3>Family {this.state.tagModal.tag.Family}</h3>

                        {this.state.tagModal.tag.Status === 'Reserved' &&
                            <div>
                                Someone just took this tag and is in the process of completing the contact form. Please choose another tag!
                                <br></br>
                                <br></br>
                                <button className="button button--primary button--block" onClick={this.closeTagModal.bind(this)}>Back to Tree</button>
                            </div>
                        }
                        {this.state.tagModal.tag.Status === 'Taken' && this.state.tagModal.numAvailable === 0 &&
                            <div>
                                All of the tags for this family have been taken! Please find another tag on the tree!
                                <br></br>
                                <br></br>
                                <button className="button button--primary button--block" onClick={this.closeTagModal.bind(this)}>Back to Tree</button>
                            </div>
                        }
                        {this.state.tagModal.tag.Status !== 'Reserved' && this.state.tagModal.numAvailable > 0 &&
                            <div>
                                {this.state.tagModal.tag.Status === 'Available' &&
                                    <div>This tag is for a <strong><span className="lowercase">{this.state.tagModal.tag.Gender}</span></strong> that is <strong>{this.state.tagModal.tag.AgeText} old</strong>. {this.state.tagModal.tag.Gender === 'Boy' && <span>He</span>}{this.state.tagModal.tag.Gender === 'Girl' && <span>She</span>} is child #{this.state.tagModal.tag.ChildNumber} in a family of {this.state.tagModal.tag.TotalChildren}.</div>
                                }
                                {this.state.tagModal.tag.Status === 'Taken' &&
                                    <div>This tag was already taken but other children in the same family are still available. Select another child, or return to the tree to pick another tag.</div>
                                }
                                <br></br>
                                <strong>All of the Children in this Family</strong>
                        <br />
                        <br />

                                {this.state.tagModal.familyTags.map((tag, index) =>
                                    <TagSelector className="tag-selector" key={index} index={index} item={tag} selections={this.state.tagModal.selections} />
                                )}
                                <br></br>
                                {this.state.tagModal.numAvailable > 0 &&
                                    <button className="button button--primary button--block" onClick={this.proceedToForm.bind(this, this.state.tagModal.selections)}>Proceed with these Selections</button>
                                }
                                {this.state.tagModal.numAvailable === 0 &&
                                    <button className="button button--primary button--block" onClick={this.closeTagModal.bind(this)}>Back to Tree</button>
                                }
                            </div>
                        }
                    </Rodal>

                    <Rodal height={600} visible={this.state.thankYouModal.visible} onClose={this.closeThankYouModal.bind(this)}>
                        <h3>Thank You!</h3>
                        <p>You are bringing cheer this season to {this.state.thankYouModal.count > 1 && <em>{this.state.thankYouModal.count} children</em>}{this.state.thankYouModal.count === 1 && <span>a child</span>} from a family who could really use it!<br></br><br></br>{this.state.thankYouModal.text}</p>
                        <p>Your information has been received, and we will be in touch with you within a few days with further details.</p>
                        <p>Click continue to watch how your generosity has moved us closer to our goal of helping all of these families!</p>
                        <p>Have a Merry Christmas!</p>
                        <div className="text-center m-t-2">
                            <button className="button button--primary button--block" onClick={this.closeThankYouModal.bind(this)}>Continue</button>
                        </div>
                    </Rodal>

                    <Rodal height={640} visible={this.state.helpModal.visible} onClose={this.closeHelpModal.bind(this)}>
                        {this.state.helpModal.page === '1' &&
                            <div>
                                <h4>What is the Virtual Giving Tree?</h4>
                                <p>The virtual Giving Tree is made to function very similar to the real thing.  The tree is full of tags, each tag representing a child in need of gifts this Christmas.  All of the information is kept confidential by using a letter to represent the child's family and a number representing the child.</p>
                                <div className="text-center m-t-2">
                                    <button className="button button--primary button--block" onClick={this.toHelpPage2.bind(this)}>Next</button>
                                </div>
                            </div>
                        }
                        {this.state.helpModal.page === '2' &&
                            <div>
                                <h4>How Do I Take a Tag?</h4>
                                <p>Simply click or touch a tag on the tree to show basic information about the child, including their age, gender, and family letter.  For convenience, if you want to sponsor multiple children we also list the other children in the same family. Check off each child within the family that you want to sponsor.</p>
                                <p>Once you are ready, click the "Proceed with these Selections" button and you will be taken to a form to provide your contact information. Within a few days, you will be contacted with more information about the child (or children) you selected and next steps on how to provide gifts.</p>
                                <p>Watch how the tree changes as tags are "taken" and families are fully sponsored!</p>
                                <div className="text-center m-t-2">
                                    <button className="button button--primary button--block" onClick={this.toHelpPage3.bind(this)}>Next</button>
                                </div>
                            </div>
                        }
                        {this.state.helpModal.page === '3' &&
                            <div>
                                <h4>How Will I Give My Gifts?</h4>
                                <p>Information about the gift giving process will be provided by email when you "take" a tag. Contact Heather MacClay (<a href="mailto:heather@restorationchurchpa.org">heather@restorationchurchpa.org</a>) for more information or with questions.</p>
                                <p>Have a safe and joyous Christmas!</p>
                                <div className="text-center m-t-2">
                                    <button className="button button--primary button--block" onClick={this.closeHelpModal.bind(this)}>Close</button>
                                </div>
                            </div>
                        }
                    </Rodal>

                    <div className="tree-container">
                        <img src={treeImage} alt="Christmas Trees"/> 

                        {this.state.tags.map((tag, index) =>
                            <Tag className="tag" key={index} index={index} onSelect={this.openTagModal.bind(this)} item={tag} />
                        )}

                        {this.state.gifts.map((gift, index) =>
                            <Gift className="gift" key={index} index={index} onSelect={this.openGiftModal.bind(this)} item={gift} />
                        )}

                        <button className="button button--help" onClick={this.openHelpModal.bind(this)}>Instructions</button>
                        {!this.state.isTagsRemaining &&
                            <button className="button button--notify" onClick={this.openNotificationForm.bind(this)}>New Tag Alerts</button>
                        }
                    </div>
                
                </div>
            );
        }
    }
}

export default withRouter(Tree);
